import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

const glowMap = {
  cyan: { border: "rgba(0, 240, 255, 0.55)", shadow: "rgba(0, 240, 255, 0.35)", text: "#00F0FF" },
  purple: { border: "rgba(176, 38, 255, 0.6)", shadow: "rgba(176, 38, 255, 0.35)", text: "#C56BFF" },
  gold: { border: "rgba(255, 215, 0, 0.6)", shadow: "rgba(255, 215, 0, 0.3)", text: "#FFD700" },
};

export const PathwayCard = ({ future, index, onChoose, testId }) => {
  const g = glowMap[future.glow_color] || glowMap.cyan;
  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.15, duration: 0.6, ease: "easeOut" }}
      whileHover={{ y: -6 }}
      onClick={() => onChoose(future)}
      data-testid={testId}
      className="relative text-left glass p-6 rounded-2xl w-full group"
      style={{
        borderColor: g.border,
        boxShadow: `0 0 28px ${g.shadow}, inset 0 1px 0 rgba(255,255,255,0.05)`,
      }}
    >
      <div className="flex items-center gap-2 font-mono-label mb-3" style={{ color: g.text }}>
        <Sparkles size={12} /> Pathway 0{index + 1}
      </div>
      <h3
        className="text-2xl md:text-3xl font-display font-semibold mb-3 leading-tight"
        style={{ color: "white", textShadow: `0 0 18px ${g.shadow}` }}
      >
        {future.title}
      </h3>
      <p className="text-xs text-white/75 leading-relaxed mb-4 origin-top-left transition-[font-size] duration-300 group-hover:text-base" data-testid={`${testId}-summary`}>
        {future.summary}
      </p>
      <div className="grid grid-cols-2 gap-2 text-xs text-white/60 mb-5">
        <div><span className="font-mono-label block mb-0.5">Income</span>{future.income_estimate}</div>
        <div><span className="font-mono-label block mb-0.5">Net worth</span>{future.net_worth}</div>
        <div><span className="font-mono-label block mb-0.5">Lifestyle</span>{future.lifestyle}</div>
        <div><span className="font-mono-label block mb-0.5">Risks</span>{future.risks}</div>
      </div>
      {future.steps?.length > 0 && (
        <div className="mb-5" data-testid={`${testId}-steps`}>
          <div className="font-mono-label mb-2" style={{ color: g.text }}>3 steps to start</div>
          <ol className="space-y-1.5">
            {future.steps.slice(0, 3).map((s, k) => (
              <li key={k} className="text-xs text-white/75 flex gap-2 transition-[font-size] duration-300 group-hover:text-sm">
                <span style={{ color: g.text }}>{k + 1}.</span> {s}
              </li>
            ))}
          </ol>
        </div>
      )}
      <div
        className="inline-flex items-center gap-2 font-display font-medium tracking-wide group-hover:gap-3 transition-[gap]"
        style={{ color: g.text }}
      >
        Enter this pathway <ArrowRight size={16} />
      </div>
    </motion.button>
  );
};
